import React, { useEffect, useRef } from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import WhatIsImmersid from '../components/WhatIsImmersid';
import HowItWorks from '../components/HowItWorks';
import ProblemsWeSolve from '../components/ProblemsWeSolve';
import PlatformCapabilities from '../components/PlatformCapabilities';
import WhoItsFor from '../components/WhoItsFor';
import TechnologyStack from '../components/TechnologyStack';
import VisionFuture from '../components/VisionFuture';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="relative bg-white">
      <Header />
      <HeroSection />
      <WhatIsImmersid />
      <HowItWorks />
      <ProblemsWeSolve />
      <PlatformCapabilities />
      <WhoItsFor />
      <TechnologyStack />
      <VisionFuture />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;